@if (isInEditor) {
  <div class="page-break-bar text-secondary" data-cy="PageBreak:editorBar">Page Break</div>
}
